import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=224537e9&scoped=true&"
import script from "./PasswordSet.vue?vue&type=script&lang=js&"
export * from "./PasswordSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224537e9",
  null
  
)

export default component.exports